import { ShopperAgentCapabilityKind } from "@redotech/redo-shopper-agent-common/capabilities/shopper-agent-capabilities";
import * as z from "zod";
import {
  promptFixIssueSchema,
  promptFixSchema,
} from "../prompt-helper/prompt-fix";

/** The changes the fix card offers for one issue in a capability's guidance; null when none could be written. */
export const draftShopperAgentCapabilityGuidanceFix = {
  name: "draftShopperAgentCapabilityGuidanceFix" as const,
  input: z.object({
    capability: z.enum(ShopperAgentCapabilityKind),
    /** Untrimmed, since the issue's offsets index into this text. */
    guidance: z.string().max(2000),
    issue: promptFixIssueSchema,
  }),
  output: z.object({ fix: promptFixSchema.nullable() }),
};
